<div class="modal-wrapper">
    <div class="body-content">
        <div *ngIf="loading" class="text-center p-3">
            <nz-spin nzTip="Loading..."></nz-spin>
        </div>

        <div class="table-responsive" *ngIf="!loading && dataSample.length > 0">
            <table class="table table-bordered table-striped">
                <thead class="table-dark">
                    <tr>
                        <th *ngFor="let col of dataFields">{{ col }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of dataSample">
                        <td *ngFor="let col of columns">{{ row[col] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="!loading && dataSample.length === 0" class="text-center p-3">
            Không có dữ liệu
        </div>
    </div>

    <div class="footer-fixed d-flex justify-content-between align-items-center p-2">
        <div>
            <label>Hiển thị: </label>
            <nz-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)" style="width: 80px;">
                <nz-option [nzValue]="10" nzLabel="10"></nz-option>
                <nz-option [nzValue]="20" nzLabel="20"></nz-option>
                <nz-option [nzValue]="50" nzLabel="50"></nz-option>
                <nz-option [nzValue]="100" nzLabel="100"></nz-option>
            </nz-select>

        </div>

        <nz-pagination [nzTotal]="totalItems" [nzPageSize]="pageSize" [nzPageIndex]="currentPage"
            [nzShowSizeChanger]="false" (nzPageIndexChange)="onPageChange($event)">
        </nz-pagination>
    </div>
</div>
